<!-- 限销商品操作 -->
<template>
    <div>
        <div v-if="isLoaded">
            <div class="demo-drawer__content data_action_form">
                <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED">
                    <v-tabs :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'"
                        :tabslist="tabForm" @tabs="(val) => { showTabs = val }" @tabHeight="(val) => { mxHeight = val }">
                        <template slot="tabs" slot-scope="scope">
                            <div class="table_content_box" v-if="scope.index == 0">
                                <!-- 主要信息 -->
                                <el-form label-width="150px" label-position="right" size="mini" class="baseForm"
                                    :model="addFormData" ref="addFormData">
                                    <el-row>
                                        <el-form-item label="级别名称" prop="levleName" :rules="[
                                            { required: true, message: '请输入名称', trigger: ['blur', 'change'] }
                                        ]">
                                            <label slot="label" :style="$common.labelStyle('级别名称')" v-html="'级别名称'"></label>
                                            <el-input class="form_codition" autofocus placeholder="请输入名称"
                                                v-model="addFormData.levleName"></el-input>
                                        </el-form-item>
                                        <el-form-item label="备注">
                                            <label slot="label" :style="$common.labelStyle('备注')" v-html="'备注'"></label>
                                            <el-input class="form_codition" placeholder="请输入信息"
                                                v-model="addFormData.remark"></el-input>
                                        </el-form-item>
                                    </el-row>
                                </el-form>
                            </div>
                        </template>
                    </v-tabs>
                </el-card>

                <div style="text-align:center; margin-top: 20px;">
                    <el-button v-if="dataActionBox.actionType != 2" type="primary"
                        @click="$emit('drawerCancel')">取消</el-button>
                    <el-button type="primary" @click="sendDataAction('addFormData')"
                        v-if="dataActionBox.actionType == 0">保存</el-button>
                    <el-button type="primary" @click="sendDataAction('addFormData')"
                        v-if="dataActionBox.actionType == 1">保存</el-button>
                </div>

            </div>
        </div>

    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import SearchScheme from "../byComponents/SearchScheme.vue";

export default {
    name: "salesPriceStrategyAction",
    props: ["actionData"],
    //import引入的组件需要注入到对象中才能使用
    components: {
        SearchScheme,
    },
    data() {
        //这里存放数据
        return {
            mxHeight: 0,
            dataActionBox: {
                showStatus: false,
                openMode: "ltr" || "rtl",
                boxTitle: "新增" || "编辑",
                actionType: 0, // 0新增，1修改
            },
            parentSearchData: {},
            seId: 0,
            cmId: 0,
            selectedDataIndex: 0,
            addFormData: {
                "levleName": "",
                "remark": ""
            },
            goodsData: [],
            addForm: {
                glcId: ''
            },
            tabForm: [],
            showTabs: "",
            DialogVisible: false, //检索
            seId: "",
            seWidth: "",
            seTitle: "",
            seType: "",
            isLoaded: false,
            options: [],
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
    },
    //方法集合
    methods: {
        // 检索Id, 索引(表格中), 标识
        openSearch(sId, index, type, sField) {
            this.DialogVisible = true
            this.seId = sId
            this.sField = sField
        },
        delGoods() {
            if (this.goodsData.length > 0) {
                this.goodsData.splice(this.selectedDataIndex, 1)
            } else {
                this.$message.error('暂无可删除的数据')
            }
        },
        //提取返回
        changeInputModel(val) {
            if (val != "" || val != undefined) {
                this.DialogVisible = false;
                if (this.goodsData.findIndex(item => item.bgmId == val.bgmId) == -1) {
                    this.goodsData.push(val)
                }
            }
        },
        getSeWidth(e) {
            this.seWidth = e + "%";
        },
        getSearchName(e) {
            this.seTitle = e;
        },

        tableRowClassName({ row, rowIndex }) {
            row.index = rowIndex;
        },

        //确认新增
        sendDataAction(formName1) {
            this.$refs[formName1].validate((valid) => {
                if (valid) {
                    // console.log('addFormData', this.addFormData)
                    this.sub();
                } else {
                    this.$message({
                        message: "请完善必填信息",
                        type: "error",
                    });
                    return false;
                }
            });
        },
        searchDataList() {
            this.$http.queryClassifyData({ classifyName: '' }).then(res => {
                if (res.status == 200) {
                    this.options = res.result
                } else {
                    this.$message.error(res.message)
                }
            })
        },
        async sub() {
            var responseData;
            if (this.dataActionBox.actionType == 0) {
                responseData = await this.$http.addPriceStrategy(this.addFormData);
            } else if (this.dataActionBox.actionType == 1) {
                responseData = await this.$http.setPriceStrategy(this.addFormData);
            }
            if (responseData.status == 200) {
                this.init();
                this.$message({
                    message: "操作成功",
                    type: "success",
                });
                this.$emit("drawerCancel");
                // this.dataActionBox.showStatus = false
                // this.$parent.getDataList()
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },

        //取消
        initActionBox(formName1) {
            var cancelTitle = this.dataActionBox.actionType == 0 ? "新增" : "修改";
            this.$confirm("确定取消" + cancelTitle + "价格策略级别维护吗?", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    this.$emit("drawerCancel");
                    // this.$parent.getDataList()
                    this.init();
                    this.$refs[formName1].resetFields();
                })
                .catch(() => { });
        },
        //初始化
        init() {
            for (let key in this.addFormData) {
                if (key == "scopeType") {
                    this.addFormData[key] = 0;
                } else {
                    this.addFormData[key] = "";
                }
            }
        },
        //父级传入
        openBox(cate, formData, oldData = "") {
            this.init();
            if (cate == 0) {
                this.dataActionBox.boxTitle = "新增";
                this.dataActionBox.openMode = "ltr";
            } else if (cate == 1) {
                this.dataActionBox.boxTitle = "编辑";
                this.dataActionBox.openMode = "rtl";
                var dataInfo = JSON.parse(JSON.stringify(oldData));
                for (let key in dataInfo) {
                    this.addFormData[key] = dataInfo[key];
                }
            } else {
                this.dataActionBox.boxTitle = "查看";
                var dataInfo = JSON.parse(JSON.stringify(oldData));
                for (let key in dataInfo) {
                    this.addFormData[key] = dataInfo[key];
                }
            }
            this.dataActionBox.actionType = cate;
            this.dataActionBox.showStatus = true;
            this.showTabs = this.dataActionBox.boxTitle + '价格策略级别维护'
            this.$nextTick(() => {
                setTimeout(() => {
                    if (this.dataActionBox.actionType != 2) {
                        this.mxHeight = this.$common.getBtnHeight()
                    } else {
                        this.mxHeight = this.$common.getHeight()
                    }
                }, 16.7)
            });
            this.filterMainField()

        },
        // 过滤表单不同类型
        filterMainField() {
            console.log(this.dataActionBox.boxTitle);
            this.tabForm = [
                {
                    jciName: this.dataActionBox.boxTitle + '价格策略级别维护',
                    jurconfigform: []
                }
            ]
        },
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        // this.$nextTick(() => {
        this.searchDataList()

        var params = this.actionData;
        this.openBox(params.cate, params.formData, params.oldData);
        this.isLoaded = true;
        // });
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() { },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style scoped>
.table_button_box {
    height: 200px;
    background-color: red;
}

.table_content_box {
    overflow-y: auto;
}

.el-row {
    display: flex;
    flex-wrap: wrap;
    padding-right: 20px;
}

.el-drawer {
    outline: none;
}
</style>
